/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invite_User_ExistsInputs */



/**
* | output |
* | --- |
* | "That email is already a portal user." |
*
* @param {Partner_Admin_Invite_User_ExistsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invite_user_exists = /** @type {((inputs?: Partner_Admin_Invite_User_ExistsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invite_User_ExistsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese E-Mail ist bereits ein Portal-Benutzer.")
	return /** @type {LocalizedString} */ ("That email is already a portal user.")
});